import { balancePanelStyle as style } from './balance-panel.style';
import { jupiterButton } from 'styled-system/recipes';
import { SabaCoinIcon } from '@/components/icons/saba-coin-icon';
import { Button } from '@nf/ui';
import { useAccountInfo } from '@/hooks/query/account';
import { useAGBalance } from '@/hooks/query/balance';
import { useTranslations } from 'next-intl';
import { transactionService } from '@/services/jupiter/transaction-service';
import { Link } from '@/navigation';
import clsx from 'clsx';
import { useSiteStore } from '@/store/site';

export const BalancePanel = ({
	setShowBalancePanel
}: {
	setShowBalancePanel?: (value: boolean) => void;
}) => {
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const { AGData, IsAGSuccess } = useAGBalance(user?.AG === 1);
	const [isShowBalance, setIsShowBalance] = useSiteStore(state => [state.isShowBalance, state.setIsShowBalance]);

	const handleButtonClick = () => {
		setShowBalancePanel && setShowBalancePanel(false);
	}

	const switchShowBalance = () => {
		// TODO 需補上kafka
		setIsShowBalance(!isShowBalance);
	}

	return (
		<section
			data-name="balancePanel_container"
			className={style.balancePanel}
		>
			<div className={style.switch}>
				<span className={style.switchText}>{t('lbl_ShowBalance')}</span>
				<div
					className={style.switchBtn}
					data-active={isShowBalance}
					onClick={switchShowBalance}
				>
					<div className={style.switchDot}></div>
				</div>
			</div>
			<div className={style.panel}>
				<div className={style.title}>{t('lbl_SABAWallet')}</div>
				<div className={style.group}>
					<div className={style.row}>
						<span className={style.label}>{t('lbl_AvailableFunds')}</span>
						<span className={style.amount}>{user?.BCredit}</span>
					</div>
					<div className={style.row}>
						<span className={style.label}>{t('lbl_PendingFunds')}</span>
						<span className={style.amount}>{user?.GCredit}</span>
					</div>
				</div>
				<div className={style.divider}></div>
				{
					user?.AG ? (
						<>
							<div className={style.group}>
								<div className={style.row}>
									<span>{t('lbl_sportbook')}</span>
									<span>
										{user?.BCredit}
									</span>
								</div>
								<div className={style.row}>
									<span>{t('lbl_AG')}</span>
									<span>
										{transactionService.getDisplayAmount({
											currencyName: '',
											amount: IsAGSuccess && AGData?.AvailableFunds ? AGData.AvailableFunds : 0,
											enableCurrencyDisplay: false,
											currencySymbol: '',
										})}
									</span>
								</div>
							</div>
							<div className={style.divider}></div>
						</>
					) : null
				}
				<Link href="/transaction/deposit">
					<Button onClick={handleButtonClick} className={clsx(jupiterButton(), style.button)}>{t('lbl_StatementTransaction')}</Button>
				</Link>
				{
					!user?.TransFd ? null :
						(
							<Link href="/transaction/transfer">
								<Button onClick={handleButtonClick} className={clsx(jupiterButton(), style.button)}>{t('lbl_TransferBtn')}</Button>
							</Link>
						)
				}
			</div>
			{
				!user?.SabaCoinWallet ? null :
					(
						<div className={style.panel}>
							<div className={style.title}>{t('lbl_RPSabaCoins')}</div>
							<div className={style.group}>
								<div className={style.row}>
									<span className={style.label}>{t('lbl_AvailableFunds')}</span>
									<span className={style.amount}><SabaCoinIcon />{user?.SabaCoinWallet?.AvailableFund}</span>
								</div>
								<div className={style.row}>
									<span className={style.label}>{t('lbl_PendingFunds')}</span>
									<span className={style.amount}><SabaCoinIcon />{user?.SabaCoinWallet?.PendingFund}</span>
								</div>
							</div>
						</div>
					)
			}
			<div className={style.time}>
				<div className={style.row}>
					<span>{t('lbl_LastLogin')}</span>
					<span>{user?.LLogin}</span>
				</div>
				<div className={style.row}>
					<span>{t('lbl_LastTrans')}</span>
					<span>{user?.LTran}</span>
				</div>
			</div>
		</section>
	)
}